import React from "react";
import { MapPin } from "lucide-react";

const TEAM = [
  {
    name: "Francesca Mometti",
    role: "Head of Magis Pulse",
    location: "Brussels, Belgium",
    bio: "Coordinates and supports associations in their day-to-day activities, providing guidance on organizational, administrative and strategic matters. Expertise in payment systems and the European regulatory framework.",
    image: "/team/francesca.jpg",
  },
  {
    name: "Mauro Comegna",
    role: "Head of Magis do Brasil",
    location: "São Paulo, Brazil",
    bio: "Holds full responsibility for operations in Brazil and key reference for business development across LATAM. A strong operations background ensures quality of work aligns with strategic make-or-buy decisions.",
    image: "/team/mauro.jpg",
  },
  {
    name: "Mattia Volpi",
    role: "Head of Magis Italy",
    location: "Italy",
    bio: "Leads operations in Italy and oversees resources across all projects. Strong background in Innovation and Strategy; in charge of new consulting solutions, global partnerships and international expansion.",
    image: "/team/mattia.jpg",
  },
];

export const Leadership = () => {
  return (
    <section
      id="leadership"
      data-testid="leadership-section"
      className="bg-brand-off-white text-brand-teal py-24 md:py-40"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16">
          <div className="md:col-span-3">
            <span className="overline text-[#2EC4B6]">— Our people</span>
          </div>
          <div className="md:col-span-9">
            <h2
              className="font-display text-4xl md:text-6xl lg:text-7xl tracking-tighter leading-[1.05]"
              data-testid="leadership-heading"
            >
              Three leaders.<br />
              <span className="text-brand-teal/40">One shared standard.</span>
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 lg:gap-14 max-w-5xl mx-auto">
          {TEAM.map((m, i) => (
            <article
              key={m.name}
              data-testid={`leader-card-${i}`}
              className="group"
            >
              <div className="relative overflow-hidden bg-brand-teal aspect-square mb-6 max-w-[280px] mx-auto md:mx-0">
                <img
                  src={m.image}
                  alt={m.name}
                  className="absolute inset-0 w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0A2427]/80 via-transparent to-transparent opacity-70 group-hover:opacity-30 transition-opacity duration-500" />
                <div className="absolute bottom-3 left-3 right-3 flex items-center gap-2 text-white/95 text-xs">
                  <MapPin size={12} className="text-[#2EC4B6]" />
                  <span className="overline">{m.location}</span>
                </div>
              </div>
              <h3 className="font-display text-xl md:text-2xl tracking-tight mb-1">
                {m.name}
              </h3>
              <p className="text-[#2EC4B6] font-medium text-sm tracking-wide mb-4">
                {m.role}
              </p>
              <p className="text-muted-dark text-sm leading-relaxed max-w-sm">{m.bio}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Leadership;
